<!-- Header section -->
<app-header></app-header>

<!-- Hero section -->
<div class="lp_hero gradient_bg" style="background-image: url('/assets/images/contact-bg.webp');">
  <div class="lp_hero_content d-grid align-items-center">
    <div class="lp_hero_text">
      <h1 class="lp_h1 text-capitalize">Help your clients protect and build their legacy.</h1>
      <p class="lp_p">Family Central provides your clients a safe haven for important documents and building their legacies for generations to come.</p>
      <a routerLink="/professional/signup" class="primary_btn">Sign up</a>
      <p class="lp_p mt-2 mb-0">No Cost To Advisors</p>
    </div>
    <div class="lp_hero_image">
      <div class="welcome_video_wrapper card_wrapper">
        <div class="welcome_video_content card_container">
          <div class="welcome_video ratio ratio-16x9">
            <iframe src="https://player.vimeo.com/video/910873205?h=6096bd7bfa&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen title="Welcome, Trusted Professional Advisors">
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Feature sections -->
<div class="lp_features">
  <div class="px-90 m-auto text-center">
    <div class="feature_content">
      <div class="features_top mb-5">
        <h2 class="lp_h2 mb-5">The only app in the market that provides your clients with a safe haven for their most valuable information. </h2>
        <p class="lp_p">Family Central works with Trusted Professional Advisors that are looking for ways to manage clients’ important financial and life planning information in a secure and consistent manner.</p>
      </div>

      <div class="features_list d-flex">
        <div class="single_feature">
          <div class="feature_img mb-4">
            <img src="/assets/images/feature_1.webp" width="208" height="270" alt="" loading="lazy">
          </div>
          <p class="lp_p">Legacy Messages</p>
        </div>
        <div class="single_feature">
          <div class="feature_img mb-3">
            <img src="/assets/images/feature_2.webp" width="208" height="230" alt="" loading="lazy">
          </div>
          <p class="lp_p">Personal Vault</p>
        </div>
        <div class="single_feature">
          <div class="feature_img mb-4">
            <img src="/assets/images/feature_3.webp" alt="" width="208" height="270" loading="lazy">
          </div>
          <p class="lp_p">Live Customer Care</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Is right for you section -->
<div class="is_right gradient_bg" style="background-image: url('/assets/images/contact-bg.webp');">
  <div class="px-90 m-auto text-center">
    <div class="is_right_content py-5">
      <div class="features_top mb-5">
        <h2 class="lp_h2 mb-4 text-capitalize">Everything in the right place</h2>
        <p class="lp_p">Help your clients manage their everyday life by organizing important documents and prepare for life’s inevitable emergencies.</p>
      </div>

      <div class="features_list d-grid">
        <!-- First Image -->
        <div class="image-container">
          <img src="/assets/images/professionals/right_palce_1.webp" alt="professionals" class="image">
          <div class="overlay">
            <h3 class="header">Planning</h3>
            <p class="paragraph_isright">Empower your clients to plan ahead and set up important documents and actions for those inevitable life emergencies.</p>
          </div>
        </div>

        <!-- Second Image -->
        <div class="image-container">
          <img src="/assets/images/professionals/right_palce_2.webp" alt="professional" class="image">
          <div class="overlay">
            <h3 class="header">Legacy</h3>
            <p class="paragraph_isright">Help your clients leave a legacy for their loved ones for generations to come.</p>
          </div>
        </div>

        <!-- Third Image -->
        <div class="image-container">
          <img src="/assets/images/professionals/right_palce_3.webp" alt="professaionalplace" class="image">
          <div class="overlay">
            <h3 class="header">Organization</h3>
            <p class="paragraph_isright">Provide a platform where your clients can manage their day-to-day efficiently so they can spend more time with those who matter the most — their family.</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Security tech section -->
<div class="securuty_tech">
  <div class="px-90 m-auto">
    <div class="features_top text-center">
      <h2 class="lp_h2 mb-4 text-capitalize">Your clients are safe with us</h2>
      <p class="lp_p">At Family Central, your clients’ critical information is safeguarded with the most up-to-date data security because our members deserve peace of mind.</p>
    </div>
    <div class="security_content py-5">
      <div class="security_parent d-grid">
        <div class="security_chaild">
          <div class="security_img">
            <img src="/assets/images/professionals/wowrack-logo.svg" alt=""/>
          </div>
        </div>
        <div class="security_chaild">
          <div class="security_text">
            <p class="lp_p">Wowrack.com provides our infrastructure services, private hosting and cloud infrastructure with bank encrypted levels of security.</p>
          </div>
        </div>
        <div class="security_chaild">
          <div class="security_img">
            <img src="/assets/images/professionals/microsoft-azure-logo.svg" alt=""/>
          </div>
        </div>
        <div class="security_chaild">
          <div class="security_text">
            <p class="lp_p">Azure.microsoft.com provide Family Central with data protection through 256-bit AES standard and encryption on our applications and services at their global data centers.</p>
          </div>
        </div>

        <div class="security_chaild">
          <div class="security_img">
            <img src="/assets/images/professionals/arctic-logo.svg" alt=""/>
          </div>
        </div>
        <div class="security_chaild">
          <div class="security_text">
            <p class="lp_p">Arcticwolf.com provides 24/7 monitoring detection, risk management and proactive security posture for global  fortune 100  companies and Family Central.</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Advisor to contact section -->
<div class="advisor_contact gradient_bg" style="background-image: url('/assets/images/contact-bg.webp');">
  <div class="px-90 m-auto text-center">
    <div class="resource_content py-5">
      <div class="features_top mb-5">
        <h2 class="lp_h2 mb-4 text-capitalize">A resource for Advisors to connect</h2>
        <p class="lp_p">Meet all of your clients’ needs in one easy-to-use platform and continue to build trust and provide a new value to your clients that sets your practice apart.</p>
      </div>

      <div class="advisor_resource d-grid">
        <div class="resource_list">
          <!-- questions of FAQ's -->
          <div class="faq-accordion" id="accountAccordion">
            <!-- loop of questions  -->
            <div class="card">
              <div class="card-header">
                <a class="collapsed btn" data-bs-toggle="collapse" href="#accountQues1" aria-expanded="true">Organize</a>
              </div>
              <div id="accountQues1" data-bs-parent="#accountAccordion" class="show collapse">
                <div class="card-body lp_p">
                  Keep track of documents you need to share with clients so you both have easy access to them.
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                <a class="collapsed btn" data-bs-toggle="collapse" href="#accountQues2">Protect</a>
              </div>
              <div id="accountQues2" data-bs-parent="#accountAccordion" class="collapse">
                <div class="card-body lp_p">
                  Our bank-level encryption gives you and your clients peace of mind that documents are securely stored.
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                <a class="collapsed btn" data-bs-toggle="collapse" href="#accountQues3">Connect</a>
              </div>
              <div id="accountQues3" data-bs-parent="#accountAccordion" class="collapse">
                <div class="card-body lp_p">
                  Track your meetings, communication and next steps with your clients.
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="resource_img">
          <img src="/assets/images/technology-image.webp" alt="" />
        </div>
      </div>
    </div>
  </div>

</div>


<!-- Ask us anything section -->
<div class="ask_anything mb-5">
  <div class="px-90 m-auto">
    <div class="ask_anything_top text-center mb-5">
      <h2 class="lp_h2 text-capitalize">Ask us anything</h2>
      <p class="lp_p">We are always here to answer your questions.</p>
      <p class="lp_p">or feel free to <a routerLink="/contactus" class="text_red fw-700">Contact Us.</a></p>
    </div>
    <div class="ask_anything_tabs">
      <div class="ask_tabs_accordion" id="professionalsAccordion">
        <div class="card">
          <div class="card-header">
            <a class="collapsed btn" data-bs-toggle="collapse" href="#proQuestion1" aria-expanded="true">How much does Family Central cost for my clients?</a>
          </div>
          <div id="proQuestion1" class="collapse show" data-bs-parent="#professionalsAccordion">
            <div class="card-body lp_p">
              Family Central offers a free 14-day trial period for subscribers. For a family (up to 8 members, including the subscriber), the subscriber pays $199 annually for one year or $299 annually for two years. Your subscription includes 250 GB of storage. If additional family members are needed, the add-on fee is $99 annually for an additional 8 family members. If additional storage is needed, the add-on fee $99 for an addition 250 GB of storage.
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <a class="collapsed btn" data-bs-toggle="collapse" href="#proQuestion2">
              Can I cancel at any time?
            </a>
          </div>
          <div id="proQuestion2" class="collapse" data-bs-parent="#professionalsAccordion">
            <div class="card-body lp_p">
              If a client chooses to cancel their subscription, they will be given 30 days to move the data to an alternate storage location.  After 30 days, we will delete all data from our records.
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <a class="collapsed btn" data-bs-toggle="collapse" href="#proQuestion3">
              What features can I offer my clients?
            </a>
          </div>
          <div id="proQuestion3" class="collapse" data-bs-parent="#professionalsAccordion">
            <div class="card-body lp_p">
              <p> The platform provides a centralized solution for comprehensive life preparation, ensuring your clients are ready for various situations. It offers a convenient space to organize essential information, including:</p>
              <ul>
                <li>Financial Planning</li>
                <li>Wills and Estate Plans</li>
                <li>Medical Records</li>
                <li>Passwords</li>
                <li>Video Recordings for your loved ones</li>
              </ul>
              <p>By utilizing this service, you empower your clients to navigate life's uncertainties with ease and ensure that your important details are securely stored in one accessible location.</p>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <a class="collapsed btn" data-bs-toggle="collapse" href="#proQuestion4">
              How many clients can I manage on the platform?
            </a>
          </div>
          <div id="proQuestion4" class="collapse" data-bs-parent="#professionalsAccordion">
            <div class="card-body lp_p">

              <p> For a family, accommodating up to 8 members, including the primary account holder, we offer two subscription options:</p>
              <ul>
                <li class="pb-3">
                  Choose between an annual payment of $199 for one year or opt for a two-year plan at $299 annually, both of which include a generous 250 GB of storage.
                </li>
                <li>
                  If your client’s family surpasses the initial 8 members, expanding their coverage is straightforward with our add-on feature. For an annual fee of $99, they can include an additional 8 family members, ensuring that our platform adapts seamlessly to their evolving needs.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <a class="collapsed btn" data-bs-toggle="collapse" href="#proQuestion5">
              Is my clients’ information safe?
            </a>
          </div>
          <div id="proQuestion5" class="collapse" data-bs-parent="#professionalsAccordion">
            <div class="card-body members_list_wrapper">
              At the core of Family Central’s functionality is its security. Our commitment to each and every family member is to keep their personal information safe and secure.  Family Central uses bank-level encryption technology, is SOC 2 compliant, HIPAA compliant, GDPR ready,
              CCPA ready, and registered with Dun & Bradstreet. Microsoft Azure.com provides our data protection through AES-256 encryption on our applications and services at their global data centers, and Artic Wolf provides 24/7 monitoring detection, risk management, and
              proactive security posture for Family Central, as well as global Fortune 100 companies.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="get_started_section">
  <div class="px-90 m-auto">
    <div class="get_started_content d-grid align-items-center">
      <div class="get_started_image">
        <img class="w-100" src="/assets/images/coworkers-watching-a-macbook-mockup-sitting-on-a-sofa.webp" alt="" loading="lazy">
      </div>
      <div class="get_started_box">
        <h2 class="h2 mb-4">Are you ready to get started with Family Central?</h2>
        <form [formGroup]="emailForm">
          <div class="form-group get_started_field">
            <input type="email" name="email" id="email" class="form-control" placeholder="Enter your email address" formControlName="email">
            <button type="submit" class="primary_btn" (click)="goToSignUp()">Sign up</button>
          </div>
          @if (emailForm.get('email').hasError('required') && emailForm.get('email').touched) {
            <div class="text-danger">
              Email is required.
            </div>
          }
          @if (
            emailForm.get('email').hasError('pattern')&&
            emailForm.get('email').touched
            ) {
            <div
              class="text-danger"
              >
              Email format should be email&#64;email.com
            </div>
          }
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Footer section -->
<app-footer></app-footer>
